import { Injectable } from '@angular/core';
import { AssetType } from '../models/Assets/AssetType';
import { ApiAssetService } from '../api-services/asset.api.service';

@Injectable({
  providedIn: 'root'
})
export class AssetTypeService {

  public types: AssetType[] = [];
  constructor(private assetAPIService: ApiAssetService) {
    this.getAssetTypes();
   
   }

  getType(assetTypeId: number): string {
    return this.types.filter(s => s.assetTypeId == assetTypeId)[0].type;
  }

  getId(assetType: string): number {
    return this.types.filter(s => s.type == assetType)[0].assetTypeId;
  }

  getAssetTypes(){
    this.assetAPIService.getAssetTypes().subscribe(assetTypes => {
      this.types = assetTypes;
    });
  }
}
